"use client";

import { toast } from "sonner";
import type { AppointmentWarning } from "@/lib/appointments-api";

/**
 * Fires a single warning toast listing every message (one per line). Longer-lived
 * than a normal toast so a booking conflict isn't missed; an optional Undo action
 * (used by drag-reschedule) reverts the move.
 *
 * The warnings themselves come from lib/appointments-api — its create/update/
 * saveAppointmentMove functions always preserve the additive `warnings` array
 * (pathfinder U4: the warning-discarding variants were deleted).
 */
export function showAppointmentWarnings(
  warnings: AppointmentWarning[],
  opts: {
    title: string;
    duration?: number;
    undo?: { label: string; onUndo: () => void };
  }
): void {
  if (warnings.length === 0) return;
  const description = warnings
    .map((w) => w.message)
    .filter(Boolean)
    .join("\n");
  toast.warning(opts.title, {
    description: description || undefined,
    duration: opts.duration ?? 12000,
    ...(opts.undo
      ? { action: { label: opts.undo.label, onClick: opts.undo.onUndo } }
      : {}),
  });
}
